import React, { Fragment, useEffect } from "react";
import "../../styles/common.css";
import "../../styles/auth.css";
import { Link, Outlet } from "react-router-dom";
import logo from "../../assets/images/logo.svg";


const Layout = () => {
useEffect(() => {
    // 1. Create and configure the meta tag
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    meta.id = "auth-meta-robots"; // Unique ID to easily target for removal
    document.head.appendChild(meta);

    // 2. Cleanup function: runs when the user navigates away from auth pages
    return () => {
      const existingMeta = document.getElementById("auth-meta-robots");
      if (existingMeta) {
        existingMeta.remove();
      }
    };
  }, []);
  return (
    <Fragment>
      <div className="auth-root" >
        <div className="auth ">
          <section className="main">

            <div className="logo">
              <img src={logo} alt="Roam" />
            </div>

            <Outlet />



          </section>
          <div className="footer fd-row g-16">
            <Link className="fs-10 color-white" to="/terms">Terms and Conditions</Link>
            <div className="divider"><svg xmlns="http://www.w3.org/2000/svg" width="2" height="25" viewBox="0 0 2 25" fill="none">
              <path d="M1 0.870117C1 19.1275 1 23.8107 1 23.8701" stroke="#292929" stroke-linecap="square" />
            </svg></div>
            <Link className="fs-10 color-white" to="/privacy">Privacy Policy</Link>
          </div>

        </div>
      </div>
    </Fragment>
  );
};

export default Layout;
